import { of } from 'rxjs';
var updateBiometricGeneratedState = function updateBiometricGeneratedState(state) {
  var biometricConsents = state.getIn(['biometrics', 'index']).valueSeq().sort(function (a, b) {
    return b.createdAt - a.createdAt;
  });
  return state.setIn(['biometrics', 'list'], biometricConsents);
};
var updateBiometricGeneratedState$ = of(updateBiometricGeneratedState);
var processBiometricConsents = function processBiometricConsents(consents) {
  return consents;
};
function formatStatus(status) {
  return capitalize(status);
}
function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}
export { processBiometricConsents, updateBiometricGeneratedState$, formatStatus };